angular.module('rentalListingModule').component('rentalListingEdit', {
	templateUrl: 'rentalListingEdit/rentalListingEdit.html',
	bindings: {
		listing: '<',
		user: '<',
		filters: '<',
		isMobile: '<',
		errorMessages: '<',
		emailUsRpc: '<',
		buildingSearchRpc: '<',
		brokerSearchRpc: '<',
		unitSearchRpc: '<',
		companyPhone: '<',
		termsOfUseUrl: '<',
		privacyPolicyUrl: '<',
		onSubmit: '&',
		uploadRpc: '<',
		activeStep: '<',
		steps: '<',
		maxPrice: '<',
		minPrice: '<',
		maxSqft: '<',
		minSqft: '<',
		submitInProgress: '<',
		onFieldChange: '&',
		onScrollToError: '&',
		uploadImageLimit: '<'
	},
	controller: ['$http', '$timeout', 'PubSub', function($http, $timeout, PubSub) {
		var ctrl = this;
		this.saveChanges = function() {
			if (this.form.$valid) {
				this.onSubmit({form: this.form, type: ''});
			} else if(ctrl.isMobile) {
				ctrl.onScrollToError();
			}
		};
		this.republishListing = function() {
			ctrl.listing.republish = !ctrl.listing.republish;
			ctrl.listing.unpublish = false;
		};
		this.unpublishListing = function() {
			ctrl.listing.unpublish = !ctrl.listing.unpublish;
			ctrl.listing.republish = false;
		};

		this.fieldChange = function(key) {
			this.onFieldChange({form: this.form, key: key});
		};
	}]
});
